import axios from 'axios'
import Response from '@/structs/Response'

const axiosInstance = axios.create({
  baseURL: '/',
  transformResponse: [
    (data) => {
      let resp

      try {
        resp = JSON.parse(data)
      } catch (error) {
        throw Error(`[requestClient] Error parsing response JSON data - ${JSON.stringify(error)}`)
      }

      const myResponse = Object.assign(new Response(), resp)

      if (myResponse.status === 'success') {
        return myResponse.data
      } else {
        if (myResponse.status === 'error' && myResponse.message !== null && myResponse.message.length > 0) {
          throw Error(myResponse.message)
        } else {
          throw Error(`[requestClient] Request failed with reason -  ${data}`)
        }
      }
    }
  ]
})

export default axiosInstance
